import React, { useEffect } from 'react';
import { Flex, Skeleton, Typography } from 'antd';
import { Link, useParams } from 'react-router-dom';

import { StepTitle } from '../../steps/StepTitle';
import { StepList } from '../../steps/StepList';
import { useLazyReadYookassaOAuthQuery } from '../../../service/paymentSettings.api';

const { Text } = Typography;

export const YookassaStepConnect = () => {
    const { id } = useParams();

    const [getLink, { isLoading, data, isSuccess }] =
        useLazyReadYookassaOAuthQuery();

    useEffect(() => {
        if (id) {
            getLink({ shop_id: +id }, true);
        }
    }, [id]);

    return (
        <Flex vertical gap={8}>
            <StepTitle text={'Шаг 2 Предоставление доступа'} />

            <StepList>
                <Text>Для предоставления доступа необходимо:</Text>
                {isLoading && <Skeleton />}
                {isSuccess && data?.link && (
                    <Text>
                        1. перейти{' '}
                        <Link
                            rel='noopener noreferrer'
                            target={'_blank'}
                            to={data.link}
                        >
                            по ссылке
                        </Link>
                        , чтобы получить ключ
                    </Text>
                )}
                <Text>2. выбрать созданный магазин из списка</Text>
                <Text>3. подтвердить выдачу доступа через СМС</Text>
            </StepList>
        </Flex>
    );
};
